import React, { useEffect, useRef, useState } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { Link, useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import "./Login.css";
import {
  FormControl,
  IconButton,
  InputAdornment,
  OutlinedInput,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import Modal from "@mui/material/Modal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AuthLeft from "./AuthLeft";
import { useLocation } from "react-router-dom";
import {
  AccountVerify,
  forgotPassword,
  PreChecker,
  ResetPassword,
  SendOtp,
} from "../../services/auth";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "#fff",
  // border: '2px solid #000',
  boxShadow: 24,
  borderRadius: "10px",
  outline: "none",
  "@media(max-width:767.98px)": {
    width: "75%",
  },
  p: 4,
};

const label = { inputProps: { "aria-label": "Checkbox demo" } };

export default function SignInSide() {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const lg = useMediaQuery(theme.breakpoints.up("lg"));
  //   const path = usercalls();
  const [email, setEmail] = useState({});
  const [password, setPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [load, setLoad] = useState(false);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [isOpen, setIsOpen] = useState(false);
  const toggleVisibility = () => {
    setIsOpen((prev) => !prev);
  };

  const navigate = useNavigate();

  const location = useLocation();
  const [pathName, setPathName] = useState("forgot");
  const [allUsers, setAllUsers] = useState({});
  const [errors, setErrors] = useState({});

  const [enableOtp, setEnableOtp] = useState(false);
  const [passwordEnable, setPasswordEnable] = useState(false);

  const [otp, setOtp] = useState(Array(6).fill("")); // Array with 6 empty strings
  const inputRefs = useRef([]);

  useEffect(() => {
    const path = location?.pathname?.split("/");
    setPathName(path[1]);
  }, []);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setAllUsers({ ...allUsers, [name]: value });
  };
  const validateFocus = (e) => {
    const fieldName = e?.target?.name;
    const fieldValue = e?.target?.value;
    const value = fieldValue.trim();

    let isValid = true;
    let errorMessage = "";

    // Handle email validation
    if (fieldName === "email") {
      if (value === "" || value === undefined) {
        // errorMessage = "Email is required";
        // isValid = false;
      } else if (!/\S+@\S+\.\S+/.test(fieldValue)) {
        errorMessage = "Email is invalid";
        isValid = false;
      }
    }

    // Set errors after validation
    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: errorMessage,
    }));

    return isValid;
  };

  const validate = () => {
    let formErrors = {};
    let isValid = true;

    // Validate email
    if (!allUsers.email) {
      formErrors.email = "Email is required";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(allUsers.email)) {
      formErrors.email = "Email is invalid";
      isValid = false;
    }

    setErrors(formErrors);
    return isValid;
  };

  const handleVerifySubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setLoad(true);
      const otpString = otp?.join("");
      const data = {
        OTP: otpString,
        email: allUsers.email,
      };

      const response = await PreChecker(data);
      if (response?.data?.success === true) {
   
        toast.success("verify successfully...!");
        setPasswordEnable(true);
        setEnableOtp(false);
        setLoad(false);
      } else {

        toast.error(response?.data?.message);
        setLoad(false);
      }
    }
  };

  const handleForgotSubmit = async (e) => {
    const data = {
      type: "email",
      email: allUsers.email,
    };
    e.preventDefault();
    if (validate()) {
      setLoad(true);
      const response = await SendOtp(data);
      if (response?.data?.success === true) {
        setLoad(false);
        toast.success(response?.data?.message);
        setEnableOtp(true);
        //  setTimeout(() => {
        //    navigate('/success',{state:{forgot:true,email:allUsers.email}})
        //  }, 1500);
      } else {

        toast.error(response?.data?.message);
        setLoad(false);
      }
    }
  };

  //otp verifycation

  const handleInput = (e) => {
    const { target } = e;
    const index = inputRefs.current.indexOf(target);

    if (target.value) {
      setOtp((prevOtp) => [
        ...prevOtp.slice(0, index),
        target.value,
        ...prevOtp.slice(index + 1),
      ]);

      // Move focus to the next input field
      if (index < otp.length - 1) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e) => {
    const index = inputRefs.current.indexOf(e.target);

    // Allow only numeric input or Backspace/Delete/Tab
    if (
      !/^[0-9]{1}$/.test(e.key) &&
      e.key !== "Backspace" &&
      e.key !== "Delete" &&
      e.key !== "Tab" &&
      !e.metaKey
    ) {
      e.preventDefault();
    }

    // Handle Backspace/Delete key
    if (e.key === "Backspace" || e.key === "Delete") {
      if (otp[index] !== "") {
        // If the current input has a value, clear it
        setOtp((prevOtp) => {
          const updatedOtp = [...prevOtp];
          updatedOtp[index] = "";
          return updatedOtp;
        });
      } else if (index > 0) {
        // If the current input is empty, move focus to the previous input field
        setOtp((prevOtp) => {
          const updatedOtp = [...prevOtp];
          updatedOtp[index - 1] = ""; // Clear the previous input
          return updatedOtp;
        });
        inputRefs.current[index - 1].focus(); // Move focus to the previous field
      }
    }
  };
  const handlePaste = (e) => {
    e.preventDefault();  // Prevent the default paste action
  
    const text = e?.clipboardData?.getData("text"); // Get the pasted text from clipboard
  
    // Ensure the pasted text matches the OTP length and contains only digits
    if (!/^\d{6}$/.test(text)) {
      return; // If the pasted text isn't 6 digits, prevent pasting
    }
  
    // Split the pasted text into individual digits and update the OTP state
    const digits = text.split(""); // Convert the string to an array of digits
  
    setOtp(digits); // Update the OTP state with the new digits
  
    // Move focus to the next input after pasting (optional, if necessary)
    inputRefs.current[digits.length - 1].focus();
  };

  const handleFocus = (e) => {
    e.target.select();
  };

  //passowrd validation

  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);

  const handleClickShowConfirmPassword = () =>
    setShowConfirmPassword((show) => !show);

  const [allPassword, setAllPassword] = useState({
    password: "",
    confirmpassword: "",
  });

  const [passwordErrors, setPasswordErrors] = useState({
    password: "",
    confirmpassword: "",
  });

  const handlePasswordChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setAllPassword({ ...allPassword, [name]: value });
  };

  const validatePasswordFocus = (e) => {
    const passwordRegex = /^(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*[0-9]).{6,}$/;

    const fieldName = e?.target?.name;
    const fieldValue = e?.target?.value;
    const value = fieldValue.trim();

    let isValid = true;
    let errorMessage = "";

    // Handle email validation
    if (fieldName === "email") {
      if (value === "" || value === undefined) {
        // errorMessage = "Email is required";
        // isValid = false;
      } else if (!/\S+@\S+\.\S+/.test(fieldValue)) {
        errorMessage = "Email is invalid";
        isValid = false;
      }
    }

    // Handle password validation
    if (fieldName === "password") {
      if (value === "" || value === undefined) {
        // errorMessage = "Password is required";
        // isValid = false;
      } else if (!passwordRegex.test(value)) {
        errorMessage =
          "Password must contain at least 6 characters, one uppercase letter, one special character, and one number";
        isValid = false;
      }
    } else {
      if (value === "" || value === undefined) {
        // errorMessage = "Confirm Password is required";
        // isValid = false;
      } else if (allPassword.password != value) {
        errorMessage = "Confirm Password does not match";
        isValid = false;
      }
    }

    // Set errors after validation
    setPasswordErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: errorMessage,
    }));

    return isValid;
  };

  const validatePassword = () => {
    let formErrors = {};
    let isValid = true;

    // Validate password
    if (!allPassword.password) {
      formErrors.password = "Password is required";
      isValid = false;
    } else if (!allPassword.confirmpassword) {
      formErrors.confirmpassword = "Confirm Password is required";
      isValid = false;
    } else if (allPassword.password.length < 6) {
      formErrors.password = "Password must be at least 8 characters long";
      isValid = false;
    } else if (!/^[A-Z]/.test(allPassword.password)) {
      formErrors.password = "Password must start with a capital letter";
      isValid = false;
    } else if (allPassword.confirmpassword.length < 6) {
      formErrors.confirmpassword =
        "Password must be at least 8 characters long";
      isValid = false;
    } else if (!/^[A-Z]/.test(allPassword.confirmpassword)) {
      formErrors.confirmpassword = "Password must start with a capital letter";
      isValid = false;
    } else if (allPassword.password != allPassword.confirmpassword) {
      formErrors.confirmpassword = "Confirm Password does not match";
      isValid = false;
    }

    setPasswordErrors(formErrors);
    return isValid;
  };

  const handleResetSubmit = async (e) => {
    e.preventDefault();
    if (validatePassword()) {
      setLoad(true);
      const otpString = otp?.join("");
      const data = {
        password: allPassword.password,
        confirmpassword: allPassword.confirmpassword,
        email: allUsers.email,
 
        // token: token,
      };

      const response = await ResetPassword(data);

      if (response?.data?.success === true) {
        toast.success(response.data.message);
        setLoad(false);
        setTimeout(() => {
          navigate("/login");
        }, 1000);
      } else {
        toast.error(response?.data?.message);

        setLoad(false);
      }
    }
  };

  return (
    <>
      {/* <AuthHeader /> */}
      {/* <Loader/> */}
       <ToastContainer  
             autoClose={2000}
           />
      {enableOtp === false && passwordEnable === false ? (
        <div className="register">
          <Grid
            container
            component="main"
            spacing={2}
            sx={{ alignItems: "flex-start", pt: 0 }}
            className={!md ? "medium" : ""}
          >
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
              <AuthLeft />
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
              <Grid
                container
                sx={{
                  justifyContent: "center",
                  alignItems: "center",
                  width: md ? "600px" : "auto",
                  margin: "0 auto",
                  height: "100vh",
                }}
              >
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                  <Box
                    sx={{
                      my: md && 3,
                      marginRight: 4,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",

                      // padding: "28px 25px",
                    }}
                    // className={!md && "log-bcg"}
                  >
                    <h2 className="c-accout">Forget Password</h2>

                    <p className="text-center">
                      We will send you a verification to your mail
                    </p>

                    <Box sx={{ mt: 4, width: md ? "100%" : "90%" }}>
                      <Grid container spacing={2}>
                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                          <div className="input-common">
                            <label>Email</label>
                            <TextField
                              fullWidth
                              id="fullWidth"
                              placeholder="Email"
                              name="email"
                              onChange={(e) => handleChange(e)}
                              value={allUsers.email}
                              onFocus={(e) => validateFocus(e)}
                              onInput={validateFocus}
                              error={!!errors.email}
                              helperText={errors.email}
                              required
                            />
                          </div>
                        </Grid>
                      </Grid>

                      <div className="common-btn text-center">
                        {load ? (
                          <Button fullWidth sx={{ mt: 3, mb: 2 }}>
                            Processing...
                          </Button>
                        ) : (
                          <Button
                            type="submit"
                            fullWidth
                            sx={{ mt: 3, mb: 2 }}
                            onClick={handleForgotSubmit}
                            // onClick={() => {
                            //   navigate("/trade");
                            // }}
                          >
                            Send Otp
                          </Button>
                        )}
                      </div>

                      <div className="text-center alraedy mt-50">
                        <Link to="/login" variant="body2">
                          {"Already have an account? "}
                          <span>Login</span>
                        </Link>
                      </div>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      ) : enableOtp === true ? (
        <div className="register">
          {/* <Grid
            container
            component="main"
            spacing={2}
            sx={{ alignItems: "flex-start", pt: 0 }}
            className={!md ? "medium" : ""}
          >
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
              <AuthLeft />
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
              <Grid
                container
                sx={{
                  justifyContent: "center",
                  alignItems: "center",
                  width: md ? "600px" : "auto",
                  margin: "0 auto",
                  height: "100vh",
                }}
              >
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                  <Box
                    sx={{
                      my: md && 3,
                      marginRight: 4,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",

                      // padding: "28px 25px",
                    }}
                    // className={!md && "log-bcg"}
                  >
                    <h2 className="c-accout">Verify Email</h2>

                    <p className="text-center">
                      We will send you a verification to your mail
                    </p>

                    <Box sx={{ mt: 4, width: md ? "100%" : "90%" }}>
                      <Grid container spacing={2}>
                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                          <div className="input-common">
                            <label>Email</label>
                            <TextField
                              fullWidth
                              id="fullWidth"
                              placeholder="email"
                              name="email"
                              onChange={(e)=>handleChange(e)}
                              value={allUsers.email}
                              required
                              onFocus={(e) => validateFocus(e)}
                              onInput={validateFocus}
                              error={!!errors.email}
                              helperText={errors.email}
                            />
                          </div>
                        </Grid>
                      </Grid>

                      <div className="common-btn text-center">
                        {load ? (
                          <Button fullWidth sx={{ mt: 3, mb: 2 }}>
                            Processing...
                          </Button>
                        ) : (
                          <Button type="submit" fullWidth sx={{ mt: 3, mb: 2 }} onClick={handleVerifySubmit}>
                            Verify
                          </Button>
                        )}
                      </div>

                      <div className="text-center alraedy mt-50">
                        <Link to="/login" variant="body2">
                         
                          <span>Back to login</span>
                        </Link>
                      </div>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid> */}

          <Grid
            container
            component="main"
            spacing={2}
            sx={{ alignItems: "flex-start", pt: 0 }}
            className={!md ? "medium" : ""}
          >
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
              <AuthLeft />
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
              <Box
                sx={{
                  my: md && 3,
                  marginRight: 4,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  // padding: "28px 25px",
                }}
                // className={!md && "log-bcg"}
              >
                <h2 className="c-accout">OTP Verification</h2>

                <Box sx={{ mt: 4, width: md ? "100%" : "90%" }}>
                  <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                      <div className="input-common otp-input mt-20 mb-20">
                        {/* <label>Email</label> */}
                        <form id="otp-form" className="otp-input-form">
                          {otp.map((digit, index) => (
                            <input
                              key={index}
                              type="text"
                              maxLength={1}
                              value={digit}
                              onChange={handleInput}
                              onKeyDown={handleKeyDown}
                              onFocus={handleFocus}
                              onPaste={handlePaste}
                              ref={(el) => (inputRefs.current[index] = el)}
                              className="shadow-xs flex w-[64px] items-center justify-center rounded-lg border border-stroke bg-white p-2 text-center text-2xl font-medium text-gray-5 outline-none sm:text-4xl dark:border-dark-3 dark:bg-white/5"
                            />
                          ))}
                          {/* You can conditionally render a submit button here based on otp length */}
                        </form>
                      </div>
                    </Grid>
                  </Grid>

                  <div className="common-btn text-center">
                    {load ? (
                      <Button fullWidth sx={{ mt: 3, mb: 2 }}>
                        Processing...
                      </Button>
                    ) : (
                      <Button
                        type="submit"
                        fullWidth
                        sx={{ mt: 3, mb: 2 }}
                        onClick={handleVerifySubmit}
                        // onClick={() => {
                        //   navigate("/trade");
                        // }}
                      >
                        Verify
                      </Button>
                    )}
                  </div>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </div>
      ) : (
        <div className="register">
          <Grid
            container
            component="main"
            spacing={2}
            sx={{ alignItems: "flex-start", pt: 0 }}
            className={!md ? "medium" : ""}
          >
            <Grid
              size={{ xs: 12, sm: 12, md: 12, lg: 6 }}
              sx={{ pt: 0 }}
              style={{ paddingTop: "0px" }}
            >
              <AuthLeft />
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
              <Grid
                container
                sx={{
                  justifyContent: "center",
                  alignItems: "center",
                  width: "600px",
                  margin: "0 auto",
                }}
              >
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                  <Box
                    sx={{
                      my: md && 3,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <h2 className="c-accout text-center">Reset Password</h2>
                    <p> Enter you new password</p>

                    <Box sx={{ mt: 1, width: "100%" }}>
                      <div className="input-common mt-20">
                        <label>New Password</label>
                        <FormControl
                          sx={{ mt: 1, width: "100%" }}
                          variant="outlined"
                        >
                          <OutlinedInput
                            id="outlined-adornment-password"
                            type={showPassword ? "text" : "password"}
                            value={allPassword.password}
                            placeholder="Enter your password"
                            // onChange={(e) => {
                            //   setPassword(e.target.value);
                            // }}
                            onChange={(e) => {
                              handlePasswordChange(e);
                            }}
                            onFocus={validatePasswordFocus}
                            onInput={validatePasswordFocus}
                            error={!!errors.password}
                            name="password"
                            endAdornment={
                              <InputAdornment position="end">
                                <IconButton
                                  className="eye-icon"
                                  aria-label={
                                    showPassword
                                      ? "hide the password"
                                      : "display the password"
                                  }
                                  onClick={handleClickShowPassword}
                                  edge="end"
                                >
                                  {showPassword ? (
                                    <Visibility />
                                  ) : (
                                    <VisibilityOff />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            }
                            // label="Password"
                          />
                        </FormControl>
                        <span
                          style={{
                            color: "#d32f2f",
                            fontSize: 13,
                            fontWeight: "bold",
                          }}
                        >
                          {passwordErrors.password}
                        </span>
                      </div>

                      <div className="input-common mt-20">
                        <label>Confirm Password</label>
                        <FormControl
                          sx={{ mt: 1, width: "100%" }}
                          variant="outlined"
                        >
                          <OutlinedInput
                            id="outlined-adornment-password"
                            type={showConfirmPassword ? "text" : "password"}
                            placeholder="Enter your password"
                            // onChange={(e) => {
                            //   setPassword(e.target.value);
                            // }}
                            onChange={(e) => {
                              handlePasswordChange(e);
                            }}
                            onFocus={validatePasswordFocus}
                            onInput={validatePasswordFocus}
                            error={!!errors.confirmpassword}
                            value={allPassword.confirmpassword}
                            name="confirmpassword"
                            endAdornment={
                              <InputAdornment position="end">
                                <IconButton
                                  className="eye-icon"
                                  aria-label={
                                    showConfirmPassword
                                      ? "hide the password"
                                      : "display the password"
                                  }
                                  onClick={handleClickShowConfirmPassword}
                                  edge="end"
                                >
                                  {showConfirmPassword ? (
                                    <Visibility />
                                  ) : (
                                    <VisibilityOff />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            }
                          />
                        </FormControl>
                        <span
                          style={{
                            color: "#d32f2f",
                            fontSize: 13,
                            fontWeight: "bold",
                          }}
                        >
                          {passwordErrors.confirmpassword}
                        </span>
                      </div>

                      <div className="common-btn text-center">
                        {load ? (
                          <Button fullWidth sx={{ mt: 3, mb: 2 }}>
                            Processing...
                          </Button>
                        ) : (
                          <Button
                            type="submit"
                            fullWidth
                            sx={{ mt: 3, mb: 2 }}
                            // onClick={() => {
                            //   navigate("/trade");
                            // }}
                            onClick={handleResetSubmit}
                          >
                            Reset
                          </Button>
                        )}
                      </div>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      )}
    </>
  );
}
